import { Layout } from "@/components/layout/Layout";
import {
  LoadI18nMessagesProps,
  loadIntlMessages,
} from "@/utils/loadIntlMessages";
import { getStrapiCollection, getStrapiEntity } from "@/utils/strapi";
import { routes } from "@/routes/routes";
import { page404 } from "@/const/page404";
import { queryGenericPage } from "@/strapiQuery/genericPage";
import {
  formatFirstGenericPage,
  StrapiGenericPage,
} from "@/utils/formatGenericPage";
type GetStaticPropsParams = LoadI18nMessagesProps & {
  params: { slug: string };
};

export const getStaticProps = async (ctx: GetStaticPropsParams) => {
  const layout = await getStrapiEntity<Layout>("layout", "");

  const genericPageContentPromise =
    await getStrapiCollection<StrapiGenericPage>(
      "nos-services-pages",
      queryGenericPage(ctx.params.slug)
    );

  if (genericPageContentPromise.length === 0) {
    return page404;
  }

  const intlMessages = loadIntlMessages(ctx);
  const genericPageContent = formatFirstGenericPage(genericPageContentPromise);

  return {
    props: {
      layout,
      intlMessages,
      slug: ctx.params.slug,
      heroBlock: genericPageContent.heroBlock,
      banner: genericPageContent.banner,
      presentation: genericPageContent.presentation,
      pointOfInterestList: genericPageContent.pointOfInterestList,
      nosServicesDescription: genericPageContent.nosServicesDescription,
      descriptiveBlockList: genericPageContent.descriptiveBlockList,
      agencyCardList: genericPageContent.agencyCardList,
      faq: genericPageContent.faq,
      rentACarReview: genericPageContent.rentACarReview,
      breadcrumbLabel: genericPageContent.breadcrumbLabel,
      seo: genericPageContent.seo,
      seoWithoutTemplate: genericPageContent.seoWithoutTemplate,
      defaultCanonicalRoute: routes.nosDossiers(ctx.params.slug),
    },
    revalidate: 10,
  };
};

export const getStaticPaths = () => {
  return {
    paths: [],
    fallback: "blocking",
  };
};
export { GenericPage as default } from "@/components/pages/genericPage/GenericPage";
